// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductPrice_root__2o1pY","oldPrice":"ProductPrice_oldPrice__3bmEc"};